import { render } from "./AlbumCard.vue?vue&type=template&id=8dc9558a&scoped=true"
import script from "./AlbumCard.vue?vue&type=script&lang=js"
export * from "./AlbumCard.vue?vue&type=script&lang=js"

import "./AlbumCard.vue?vue&type=style&index=0&id=8dc9558a&scoped=true&lang=scss"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc9558a"]])

export default __exports__